import { render, staticRenderFns } from "./drawerH5.vue?vue&type=template&id=f67db4fc&scoped=true"
import script from "./drawerH5.vue?vue&type=script&lang=js"
export * from "./drawerH5.vue?vue&type=script&lang=js"
import style0 from "./drawerH5.vue?vue&type=style&index=0&id=f67db4fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67db4fc",
  null
  
)

export default component.exports